import {
  FORGOT_PASSWORD_OPTIONS_REQUEST,
  FORGOT_PASSWORD_OPTIONS_SUCCESS,
  FORGOT_PASSWORD_OPTIONS_FAILURE,

  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST,
  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS,
  PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_OPTIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FORGOT_PASSWORD_OPTIONS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case FORGOT_PASSWORD_OPTIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case PREDEACTIVATED_STATUS_FORGOT_PASSWORD_REQUEST:
      return { ...state, isLoading: true, error: null };
    case PREDEACTIVATED_STATUS_FORGOT_PASSWORD_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case PREDEACTIVATED_STATUS_FORGOT_PASSWORD_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
